import { useReactGA4Init } from 'GA4/useReactGA4'
import { useAssetVariationOnLoad } from 'hooks/useAssetsVariation'

export const OnLoad = () => {
  useReactGA4Init()
  useAssetVariationOnLoad()

  return null
}
